import React, { useState } from 'react';
import {
  Box,
  Breadcrumbs,
  Card,
  Container,
  Link,
  Tab,
  Typography,
} from '@mui/material';
import Page from 'src/components/Page';

export default function Configuration() {
 

  return (
    <Page title="Reports">
      <Container maxWidth="xxl">
        <Box sx={{ mb: 4 }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Typography variant="h4">Configuration</Typography>
          </Box>
          <Breadcrumbs separator="/" aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/" sx={{ fontSize: '0.875rem' }}>
              Dashboard
            </Link>
            <Typography color="text.primary" sx={{ fontSize: '0.875rem' }}>
              Configuration
            </Typography>
          </Breadcrumbs>
        </Box>

        <Card>
         
        </Card>
      </Container>
    </Page>
  );
}
